<template>
  <section id="company_container" class="custom-container">
    <Styles>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

      <div class="columns v-align-center">
        <div class="column input-search-content">
          <CompanySelector v-model="company" v-validate="'required'" placeholder="Seleccione una empresa"
              name="company" />
            </div>
            <div class="column input-search-content">
            <b-field class="input-search" label="Buscar">
            <b-input placeholder="Buscar" type="text" name="search" v-model="search" icon-right="magnify"
              icon-right-clickable @icon-right-click="editModal = true">
            </b-input>
          </b-field>
          <b-field class="pagination-select" label ="Paginación">
            <b-select placeholder="Páginas" expanded v-model="pagination" name="pagination">
              <option v-for="option in paginationList" :value="option.id" :key="option.id" :id="option.id">
                {{ option.label }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column text-right">
          <vs-button color="primary" icon="add" class="btn-add-liquidation" @click="addLiquidation">Crear liquidación
          </vs-button>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-table :data="tableData">
            <b-table-column field="code" label="Id" v-slot="props">
              <text-highlight :queries="search">
                {{ props.row.code }}
              </text-highlight>
            </b-table-column>
            <b-table-column field="company.code" label="Empresa" v-slot="props">
              <text-highlight :queries="search">
                {{ props.row.company.name }}
              </text-highlight>
            </b-table-column>
            <b-table-column field="status" label="Estado" v-slot="props">
              <text-highlight :queries="search">
                {{ parseStatus(props.row.status) }}
              </text-highlight>
            </b-table-column>
            <b-table-column field="title" label="Nombre" v-slot="props">
              <div class="flex name-options-table">
                <span class="label-title">
                  <text-highlight :queries="search">
                    {{ props.row.title }}
                  </text-highlight>
                </span>
              </div>
            </b-table-column>
            <b-table-column field="status" label="Modalidad" v-slot="props">
              <text-highlight :queries="search">
                {{ getInitialsDescription(props.row.initials) }}
              </text-highlight>
            </b-table-column>
            <b-table-column field="options" label="Acciones" v-slot="props">
              <b-field>
                <b-button type="is-info" title="Seleccionar" @click="editRow(props.row)" style="margin-right: 3px"
                  icon-right="pencil" />
                <b-button type="is-danger" title="Eliminar" @click="deleteRow(props.row)" icon-right="delete" />
              </b-field>
            </b-table-column>
            <template #empty>
              <div class="has-text-centered">Sin registros</div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column" v-if="checkPages()">
          <vs-pagination :max="5" :total="totalPages" v-model="page" prev-icon="arrow_back" next-icon="arrow_forward">
          </vs-pagination>
        </div>
      </div>
    </Styles>
  </section>
</template>

<script>
import { DETAILS_STATUS } from "../../../global/constants";
import { ROUTES } from "../../../global/api_routes";
import { configToast, TOAST_TYPES } from "../../../global/toast";
import Styles from "./styles";
import { confirmation } from "../../../global/utils";
import CompanySelector from "../../../components/Shared/CompanySelector/index.vue";

export default {
  components: { Styles, CompanySelector },
  data: () => ({
    company: null,
    isLoading: false,
    selected: null,
    tableData: [],
    totalNumData: 0,
    originalData: [],
    search: "",
    page: 1,
    forRemove: null,
    pagination: 10,
    totalPages: 0,
    paginationList: [
      { id: 10, label: "10" },
      { id: 30, label: "30" },
      { id: 60, label: "60" },
      { id: 100, label: "100" },
      { id: 1000, label: "1000" },
    ],
    initialsCodes: [
      {
        code: "INIT",
        description: "Sincronizador",
      },
      {
        code: "MP",
        description: "Mercado pago",
      },
      {
        code: "NULL",
        description: "No aplica",
      },
    ],
  }),
  mounted() {
    this.getLiquidations();
  },
  watch: {
    company : function(){
      this.getLiquidations();
    },
    search: function (value) {
      this.tableData = this.originalData.filter((item) => {
        const string = JSON.stringify(item) + this.parseStatus(item.status);
        return new RegExp(`${value}`, "igm").test(string);
      });
    },
    page: function () {
      this.splitData();
    },
  },
  methods: {
    splitData() {
      if (!this.checkPages()) {
        this.tableData = this.originalData;
        return;
      }
      this.totalPages = Math.ceil(this.totalNumData / this.pagination);
      const offset = Math.round((this.page - 1) * this.pagination);
      const limit = Math.round(this.pagination * this.page);
      this.tableData = this.originalData.slice(offset, limit);
    },
    getInitialsDescription(code) {
      const initials = this.initialsCodes.find((item) => item.code === code);
      if (!initials) {
        return "No aplica";
      }
      return initials.description;
    },
    editRow(row) {
      this.$router.push("/view/liquidation?code=" + row.code);
    },
    deleteRow(row) {
      confirmation(this, "¿Deseas eliminar el registro?").then((result) => {
        if (!result) {
          return;
        }
        this.delete(row);
      });
    },
    checkPages() {
      return this.totalNumData > this.pagination;
    },
    parseStatus(status) {
      return DETAILS_STATUS[status]
        ? DETAILS_STATUS[status].description
        : "N/A";
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#create_device_cotainer");
      return instance.open(message, type);
    },
    delete(liquidation) {
      this.isLoading = true;
      this.$http
        .delete(ROUTES.DASHBOARD.LIQUIDATIONS.DELETE, {
          params: {
            liquidationCode: liquidation.code,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.toast("Se ha eliminado la liquidación", TOAST_TYPES.SUCCESS);
            this.getLiquidations();
            return;
          }
          this.toast(data.message, TOAST_TYPES.ERROR);
        })
        .catch((error) => (this.isLoading = false));
    },
    editRow(row) {
      this.$router.push(`/view/liquidation?code=${row.code}`);
    },
    addLiquidation() {
      this.$router.push("/view/liquidation");
    },
    getLiquidations() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.LIQUIDATIONS.GET_LIQUIDATIONS)
        .then(({ data }) => {
          if (data.code > 0) {
            this.originalData = data.info;
            this.totalNumData = data.info.length;
            this.splitData();
            return;
          }
          this.tableData= [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
